import { IServerError, IFormError } from '../../interfaces/server_response';

export type ErrorsDict = Record<string, string>;

export interface IFormErrorService {
  (err: IServerError): Record<string, string>;
}

const formErrorService: IFormErrorService = function formErrorService(err: IServerError): Record<string, string> {
  return _(err.errors)
    .groupBy('field')
    .mapValues((errors: IFormError[]) => errors.map((e) => e.message.trim()).join('-tda-'))
    .value();
};

angular.module('capability-ng-global').constant('formErrorService', formErrorService);



// WEBPACK FOOTER //
// ./app/lib/global/services/form_error_service/form_error_service.ts